import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Messages } from 'src/app/order/messages/order.messages';
import { ProposalService } from 'src/app/order/services/external/proposal/proposal.service';
import { DialogService } from 'src/app/order/services/internal/dialog/dialog.service';
import { LoadingService } from 'src/app/order/services/internal/loading/loading.service';
import { ScrollService } from 'src/app/order/services/internal/scroll/scroll.service';
import { WizardService } from 'src/app/order/services/internal/wizard/wizard.service';
import { DataStore } from 'src/app/order/store/data.store';
import { Proposal } from 'src/app/shared/models/proposal';
import { FdFieldConfigs } from 'src/app/shared/shared-components.module';
import { ConfigurationService } from 'src/app/start/services/configuration.service';
import { FormStep } from '../../../form-step';

import { RoutingService } from 'src/app/order/services/internal/routing/routing.service';
import { DataStoreService } from 'src/app/order/store/data-store.service';
import { UrlModel } from '../../../../../shared/models/url.model';
import { UrlService } from '../../../../services/external/url/url.service';
import { MatTooltip } from '@angular/material/tooltip';
import { EcommerceComplementaryInfoModel } from '../models/complementary-info.model';
import { EcommerceTechTypeEnum } from 'src/app/order/enums/ecommerce-tech-type.enum';

@Component({
  selector: 'app-payment-link',
  templateUrl: './payment-link.component.html',
  styleUrls: ['./payment-link.component.scss'],
  standalone: false
})
export class PaymentLinkComponent extends FormStep implements OnInit {

  public STEP_NUMBER = 0;

  public techType = EcommerceTechTypeEnum.PAYMENT_LINK;

  public paymentLinkModel: EcommerceComplementaryInfoModel;

  @ViewChild('tooltip') public tooltip: MatTooltip;

  constructor(
    private formBuilder: FormBuilder,
    protected proposalService: ProposalService,
    protected loadingService: LoadingService,
    protected dialogService: DialogService,
    protected dataStore: DataStore,
    protected scrollService: ScrollService,
    protected wizardService: WizardService,
    protected matDialog: MatDialog,
    protected configurationService: ConfigurationService,
    protected routingService: RoutingService,
    protected dataStoreService: DataStoreService,
    protected urlService: UrlService
  ) {
    super(
      dataStore,
      scrollService,
      wizardService,
      matDialog,
      proposalService,
      loadingService,
      dialogService,
      configurationService,
      routingService,
      dataStoreService
    );
  }

  public async ngOnInit() {
    await super.ngOnInit();
  }

  public getGatewayTooltipText() {
    return 'Descrever com detalhes os tipos de produtos/serviços comercializados. Não é o CNAE.';
  }

  public showTooltipAndStopPropagation() {
    this.tooltip.toggle();
    event.stopImmediatePropagation();
  }

  public validateUrl(url) {
    if (url && url !== '') {
      const urlModel: UrlModel = new UrlModel(url);
      this.urlService.validateStructure(urlModel).subscribe(
        (validStructureUrl) => {
          if (!validStructureUrl) {
            this.formControls.link.setValue('');
            this.dialogService.openDialog(Messages.INVALID_STRUCTURE_URL);
          }
        },
        () => {
          this.formControls.link.setValue('');
          this.dialogService.openDialog(Messages.GENERAL_ERROR);
        }
      );
    }
  }

  public next(): void {
    this.submitted = true;

    if (this.isFormGroupValid()) {
      this.dataStore.setStepStatus(this.STEP_NUMBER, this.formGroup.valid);
      this.persistData().then((persisted) => {
        if (persisted) {
          this.wizardService.nextStep();
        }
      });
    }
  }

  public persistData() {
    const paymentLinkComplementaryInfo: EcommerceComplementaryInfoModel = {
      techType: this.techType,
      ...this.formGroup.getRawValue()
    };

    const ecommerceComplementaryInfo = (this.proposal?.ecommerceComplementaryInfo || [])
      .filter((complementaryInfo) => complementaryInfo.techType !== this.techType);

    ecommerceComplementaryInfo.push(paymentLinkComplementaryInfo);

    return this.dataStore.updateProposal({ ecommerceComplementaryInfo });
  }

  public createFormGroup() {
    return this.formBuilder.group({
      link: ['', Validators.required],
      productOrServiceDetails: ['', Validators.required],
      describeHowWillBeDelivered: ['', Validators.required],
      maxValueOfTransaction: ['', Validators.required]
    });
  }

  protected proposalGetCallback(): void {}

  protected updateFields(proposal: Proposal) {
    if (proposal.ecommerceComplementaryInfo) {
      this.paymentLinkModel = proposal.ecommerceComplementaryInfo
          .filter((complementaryInfo) => complementaryInfo.techType == this.techType)
          .pop();
    }

    if (this.paymentLinkModel) {
      this.formControls.link.setValue(this.paymentLinkModel.link);
      this.formControls.productOrServiceDetails.setValue(this.paymentLinkModel.productOrServiceDetails);
      this.formControls.describeHowWillBeDelivered.setValue(this.paymentLinkModel.describeHowWillBeDelivered);
      this.formControls.maxValueOfTransaction.setValue(this.paymentLinkModel.maxValueOfTransaction);
    }
  }

  protected createFields(): FdFieldConfigs {
    return {
      link: {
        label: 'Link',
        controlName: 'link',
        maxLength: 250,
        messages: {
          required: 'Informe o link',
        },
      },
      productOrServiceDetails: {
        label: 'Descreva',
        controlName: 'productOrServiceDetails',
        maxLength: 250,
        messages: {
          required: 'Informe a descrição',
        },
      },
      describeHowWillBeDelivered: {
        label: 'Descreva',
        maxLength: 250,
        controlName: 'describeHowWillBeDelivered',
        messages: {
          required: 'Informe a descrição',
        },
      },
      maxValueOfTransaction: {
        label: 'Valor',
        controlName: 'maxValueOfTransaction',
        maxLength: 11,
        messages: {
          required: 'Informe o valor',
        },
      }
    };
  }
}
